import React from 'react';
import { Modal, Text, Alert, Group, Button } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { MODAL_SIZES } from '../../theme/mantineTheme';

export interface PossessiveTypeWipeConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

/** Confirm clearing possessive fields when RequestApprovalType Type changes to non-Possessive. */
export const PossessiveTypeWipeConfirmDialog: React.FC<PossessiveTypeWipeConfirmDialogProps> = ({
    open,
    onClose,
    onConfirm,
}) => (
    <Modal opened={open} onClose={onClose} title="Clear possessive configuration?" size={MODAL_SIZES.confirm}>
        <Text mb="md" c="dimmed">
            Switching to a non-Possessive type (e.g. Generic) will clear Possessive Scope, Possessive Target
            Attribute, Possessive Actors Attribute, and related fields. This cannot be undone.
        </Text>
        <Alert color="yellow" icon={<IconAlertTriangle size={16} />} mb="md">
            <Text size="sm" fw={700}>Possessive configuration will be cleared.</Text>
        </Alert>
        <Group justify="flex-end" mt="lg">
            <Button variant="default" onClick={onClose}>
                Cancel
            </Button>
            <Button color="yellow" onClick={onConfirm}>
                Continue
            </Button>
        </Group>
    </Modal>
);
